
























import Vue from 'vue';
import * as NoSleep from 'nosleep.js/dist/NoSleep';

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      heartRateRange: [125, 140], // default heart beat to between these values
      minHeartRate: 100,
      maxHeartRate: 180,
      isVisible: false,
      hbInterval: 0,
      heartbeatText: '',
      isRed: false,
      nextHBCountDown: 0,
      timeoutID: undefined as undefined | number,
      nosleep: new NoSleep(),
    };
  },
  methods: {
    onOpened() {
      this.stop(); // for safety guarantee

      this.hbInterval = this.getHeartbeatInterval();
      this.nextHBCountDown = this.getRandomHBCountDown();
      this.nosleep.enable();

      this.run();
    },
    onClosed() {
      this.stop();
    },
    stop() {
      this.isRed = false;
      this.nosleep.disable();
      window.clearTimeout(this.timeoutID);
    },
    run() {
      this.isRed = !this.isRed;

      if (this.isRed && --this.nextHBCountDown <= 0) {
        this.nextHBCountDown = this.getRandomHBCountDown();
        this.hbInterval = this.getHeartbeatInterval();
      }

      this.timeoutID = window.setTimeout(() => {
        this.run();
      }, this.hbInterval - 1); // minus 1ms to account for the time that "run" function used
    },
    getInterval(heartbeat: number) {
      this.hbInterval = (60 * 1000) / heartbeat;
      return Math.floor(this.hbInterval / 2); // divide by 2 as so that switching from red to white, then white back to red happens in one full interval
    },
    getRandomHeartbeat() {
      // Get a random heartbeat count given a range
      const [min, max] = this.heartRateRange;
      const range = max - min;
      const delta = Math.ceil(Math.random() * range);

      return min + delta;
    },
    getHeartbeatInterval() {
      const heartbeat = this.getRandomHeartbeat();
      this.heartbeatText = `heartbeat: ${heartbeat}`;
      const interval = (60 * 1000) / heartbeat; // number of ms to elaspe per heartbeat

      // divide by 2 as so that switching from red to white, then white back to red happens in one full interval
      return Math.floor(interval / 2);
    },
    getRandomHBCountDown() {
      // Returns a number between 5 and 15
      const base = 10;
      const deviationRange = 10;
      const halfDeviationRange = Math.floor(10 / 2);
      return (
        base + Math.ceil(Math.random() * deviationRange) - halfDeviationRange
      );
    },
    onVisibleUpdate(val: boolean) {
      this.$emit('input', val);
    },
  },
  computed: {
    rangeMarks(): { [key: number]: string } {
      const midRange =
        this.minHeartRate +
        Math.floor((this.maxHeartRate - this.minHeartRate) / 2);

      return {
        [this.minHeartRate]: this.minHeartRate.toString(),
        [midRange]: midRange.toString(),
        [this.maxHeartRate]: this.maxHeartRate.toString(),
      };
    },
  },
  watch: {
    value() {
      this.isVisible = this.value;
    },
    heartRateRange() {
      // Whenever the range value changes, we want it to take effect asap
      // We do this by setting countdown to 1
      this.nextHBCountDown = 1;
    },
  },
  beforeDestroy() {
    this.stop();
  },
});
